module.exports = __webpack_public_path__ + "media/images/icons/create-musician-f6375f16dcf39ff0e5c2590073b3339d.svg";